export default __webpack_public_path__ + "static/media/etapa5.9086bf1f.png";